var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEwa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M0 4.5v6.3L1.2 12h2.55V8.25h16.5V12h2.55l1.2-1.2V4.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.25 15.75c-1.275 0-2.25.975-2.25 2.25H9c0-1.275-.975-2.25-2.25-2.25V9h-1.5v10.5h13.5V9h-1.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.001 9.75c0-.3-.075-.525-.15-.75H9.226c-.075.225-.15.45-.15.75 0 1.275 1.35 2.25 3 2.25s2.925-.975 2.925-2.25"
})));
export default SvgEwa;